import React, { useEffect, useState, useContext, useRef, useMemo } from 'react'
import TripsContext from '../../contexts/TripsContext'
import { CAR_STATUS_ICON } from '../../utils'
import { createVehicleInfoWindow } from '../../infowindow-utils'
import { clusterMapOptions, mapOptions, vehicleMapOptions } from '../../config-map'
import Clusterer from '../../EnhancedMarkerClusterer/Clusterer'
import MarkerPointAdapter from '../../EnhancedMarkerClusterer/MarkerPointAdapter'
// import ClusterManager from '../../EnhancedMarkerClusterer/ClusterManager'
import ClusterManager from 'plugin-clustermanager/shared/ClusterManager'
import GoogleMapPointAdapter from 'plugin-clustermanager/shared/adapters/GoogleMapPointAdapter'
import GoogleMapsParser from 'plugin-clustermanager/shared/parsers/GoogleMapsParser'

type IProps = {
    vehicles: any[]
    hardwareData: any[]
    isNavegateToTrips?: any
    filtersANDApplied: boolean
    filteredImeis: number[]
}

const MarkerVehicle2 = ({ vehicles, hardwareData, filtersANDApplied, filteredImeis }: IProps) => {
    const {
        isNavegateToTrips,
        mapInstance,
        setInfoWindow,
        markerHashMap,
        isTimeToUpdate,
        isFirstLoad,
        selectedVehicles,
        currentVehicleActive
    } = useContext(TripsContext)
    const isInVehiclesView = useRef()
    const filterAppliedRef = useRef()
    const [redrawCluster, setRedrawCluster] = useState(false)
    const [lastZoomBeforeSelectedVehicle, setLastZoomBeforeSelectedVehicle] = useState<Number>(0)
    // const clusterer = useMemo(
    //     () => new Clusterer([], MarkerPointAdapter, { radius: 78, minZoom: 4, maxZoom: 15, minPoints: 1, extent: 256 }),
    //     []
    // )
    // const filteredClusterer = useMemo(
    //     () => new Clusterer([], MarkerPointAdapter, { radius: 78, minZoom: 4, maxZoom: 15, minPoints: 1, extent: 256 }),
    //     []
    // )
    // const clusterManager = useMemo(() => new ClusterManager(mapInstance), [mapInstance])

    const clusterManager = useMemo(
        () =>
            new ClusterManager<google.maps.Marker>(
                '',
                [],
                new GoogleMapsParser(),
                new GoogleMapPointAdapter(mapInstance)
            ),
        [mapInstance]
    )

    const initMap = (hardwareData = {}, vehicles = [], map): void => {
        for (const vehicle of vehicles) {
            const { imei } = vehicle
            if (!imei || !hardwareData[imei]) continue
            const { lat, lng, car_status } = hardwareData[imei] || {}

            const inMapVehicle = markerHashMap.get(imei)
            if (!inMapVehicle) {
                const icon = {
                    url: CAR_STATUS_ICON[car_status],
                    scaledSize: new google.maps.Size(50, 50)
                }

                const position = { lat: +lat, lng: +lng }
                const options = { icon, position, map }
                const mappedMarker = {
                    marker: new google.maps.Marker(options),
                    lat,
                    lng,
                    car_status,
                    scaledSize: icon.scaledSize
                }

                mappedMarker.marker.addListener('click', () => onClick(vehicle, lat, lng))
                mappedMarker.marker.infoWindowRef = {setup: null, callback: null}
                mappedMarker.marker.infoWindowRef.setup = setupInfoWindow.bind(null, vehicle, lat, lng)
                mappedMarker.marker.infoWindowRef.callback = setInfoWindow
                // mappedMarker.marker?.infoWindowRef.setup = () => setupInfoWindow(vehicle, lat, lng)
                //mappedMarker.marker.infoWindowRef.callback = setInfoWindow
            
                markerHashMap.set(imei, mappedMarker)
            }
        }
    }
    const updateSelectedVehicle = selected => {
        for (const vehicle of selected) {
            const { imei } = vehicle
            const inMapVehicle = markerHashMap.get(imei)
            const { lat, lng, car_status } = hardwareData[imei] || {}
            inMapVehicle.lat = lat
            inMapVehicle.lng = lng
            inMapVehicle.car_status = car_status
            inMapVehicle.marker.setPosition({ lat: +lat, lng: +lng })
            inMapVehicle.marker.addListener('click', () => onClick(vehicle, lat, lng))

            inMapVehicle.marker.setIcon({
                url: CAR_STATUS_ICON[car_status],
                scaledSize: inMapVehicle.scaledSize
            })
            markerHashMap.set(imei, inMapVehicle)
        }
    }
    const updateMap = (hardwareData = {}, vehicles = []): void => {
        for (const vehicle of vehicles) {
            const { imei } = vehicle
            if (!imei) continue

            const { lat, lng, car_status } = hardwareData[imei] || {}
            const inMapVehicle = markerHashMap.get(imei)
            const ruleA = inMapVehicle.lat == lat
            const ruleB = inMapVehicle.lng == lng
            const ruleC = inMapVehicle.car_status == car_status

            if (ruleA && ruleB && ruleC) continue

            inMapVehicle.lat = lat
            inMapVehicle.lng = lng
            inMapVehicle.car_status = car_status
            inMapVehicle.marker.setPosition({ lat: +lat, lng: +lng })
            inMapVehicle.marker.addListener('click', () => onClick(vehicle, lat, lng))

            inMapVehicle.marker.setIcon({
                url: CAR_STATUS_ICON[car_status],
                scaledSize: inMapVehicle.scaledSize
            })
            markerHashMap.set(imei, inMapVehicle)
        }
    }

    const setupInfoWindow = (vehicle, lat, lng) => {
        const hw = hardwareData[vehicle?.imei]
        const anchor = new google.maps.MVCObject()
        anchor.set('position', new google.maps.LatLng(+lat, +lng))
        anchor.set('anchorPoint', new google.maps.Point(0, -50))

        return createVehicleInfoWindow(hw, vehicle, undefined, anchor)
    }

    const onClick = (vehicle, lat, lng) => {
        const popup = setupInfoWindow(vehicle, lat, lng)
        setInfoWindow(popup)
    }

    const updateClusters = (zoom: boolean) => {
        if (isInVehiclesView.current) {
            clusterManager.deleteClusters()
            clusterManager.setClustersInBbox(mapInstance.getZoom())
        }
    }

    const firstCluster = () => {
        const m = []
        for (const marker of markerHashMap.values()) {
            m.push(marker.marker)
        }
        clusterManager.cluster('vehicles', m)
        // clusterer.setMarkers(m)
        // clusterer.cluster()
        updateClusters(true)
    }

    // const dragendListener = React.useCallback(
    //     () =>
    //         mapInstance?.addListener('dragend', () => {
    //             if (selectedVehicles.length == 0 || !selectedVehicles) {
    //                 updateClusters(false)
    //                 // if (!filterAppliedRef.current) updateClusters(false)
    //                 // else {
    //                 //     updateFilteredClusters(false)
    //                 // }
    //             }
    //         }),
    //     [mapInstance]
    // )
    const idleListener = React.useCallback(
        () =>
            mapInstance?.addListener('idle', () => {
                if (selectedVehicles.length == 0 || !selectedVehicles) {
                    updateClusters(true)
                    // if (!filterAppliedRef.current) updateClusters(true)
                    // else updateFilteredClusters(true)
                }
            }),
        [mapInstance]
    )

    const filterANDCluster = () => {
        const markers = []
        filteredImeis.forEach(imei => {
            if (markerHashMap.has(imei)) {
                const item = markerHashMap.get(imei)
                markers.push(item.marker)
            }
        })
        clusterManager.clusterFiltered('vehicles', markers)
        // clusterManager.setClustersInBbox(mapInstance.getZoom())
        // filteredClusterer.setMarkers(markers)
        // filteredClusterer.cluster()
        // updateFilteredClusters(true)
    }

    const setInfowindowAboveVehicle = currentVehicleActive => {
        if (currentVehicleActive) {
            const marker = markerHashMap.get(currentVehicleActive?.imei)
            const data = hardwareData[currentVehicleActive?.imei]
            data.lat = marker.marker.getPosition().lat()
            data.lng = marker.marker.getPosition().lng()

            const anchor = new google.maps.MVCObject()
            anchor.set(
                'position',
                new google.maps.LatLng(marker.marker.getPosition().lat(), marker.marker.getPosition().lng())
            )
            anchor.set('anchorPoint', new google.maps.Point(0, -50))
            const popup = createVehicleInfoWindow(data, currentVehicleActive, undefined, anchor)
            setInfoWindow(popup)
        }
    }

    useEffect(() => {
        const run = async () => {
            if (mapInstance) {
                isInVehiclesView.current = isNavegateToTrips === undefined
                filterAppliedRef.current = filtersANDApplied
                if (!isNavegateToTrips) {
                    await new Promise<void>((resolve, reject) => {
                        window.requestAnimationFrame(async () => {
                            if (filtersANDApplied) filterANDCluster()
                            else if (markerHashMap.size === 0 || isFirstLoad) {
                                await initMap(hardwareData, vehicles, null)
                                firstCluster()
                            } else if (isTimeToUpdate) {
                                await updateMap(hardwareData, vehicles)
                                firstCluster()
                            } else {
                                clusterManager.unfilter('vehicles')
                                updateClusters(true)
                                clusterManager.showClusters()
                                // if (!clusterManager.getClustersVisible()) clusterManager.showAllClusters()
                            }

                            resolve()
                        })
                    })
                    if (Array.isArray(selectedVehicles) && selectedVehicles.length > 0) {
                        updateSelectedVehicle(selectedVehicles)
                    }
                    await new Promise<void>((resolve, reject) => {
                        const ruleA = redrawCluster
                        const ruleB = (isFirstLoad && !isTimeToUpdate) || (!isFirstLoad && isTimeToUpdate)
                        const ruleC = ruleA || ruleB
                        const ruleD = !selectedVehicles || selectedVehicles.length == 0
                        window.requestAnimationFrame(() => {
                            if (ruleC && ruleD && redrawCluster) {
                                setRedrawCluster(false)
                                mapInstance.setOptions({
                                    ...mapOptions,
                                    ...clusterMapOptions
                                })
                            }
                            resolve()
                        })
                    })
                } else {
                    if (selectedVehicles.length > 0) {
                        selectedVehicles.forEach(v => {
                            const { imei } = v
                            const marker = markerHashMap.get(imei)
                            marker?.marker.setMap(null)
                        })
                        selectedVehicles.length = 0
                        setRedrawCluster(false)
                        clusterManager.hideClusters()
                        // clusterManager.hideAllClusters()
                    }
                    await new Promise<void>((resolve, reject) => {
                        window.requestAnimationFrame(() => {
                            // clusterManager.hideClusters()
                            clusterManager.hideClusters()
                            setRedrawCluster(true)
                            mapInstance.setOptions({ ...mapOptions, ...vehicleMapOptions })

                            resolve()
                        })
                    })
                }
            }
        }
        run()
    }, [mapInstance, vehicles, hardwareData, isNavegateToTrips])

    useEffect(() => {
        //dragendListener()
        idleListener()
    }, [mapInstance])

    useEffect(() => {
        if (selectedVehicles?.length > 0 && isInVehiclesView.current) {
            setInfowindowAboveVehicle(currentVehicleActive)

            for (const selected of selectedVehicles) {
                const { imei } = selected
                const marker = markerHashMap.get(imei)
                clusterManager.hideClusters()
                if (!marker.marker.getMap()) marker.marker.setMap(mapInstance)
                setRedrawCluster(true)
                setLastZoomBeforeSelectedVehicle(mapInstance.getZoom())
                mapInstance.setOptions({ ...mapOptions, ...vehicleMapOptions })
                mapInstance.panTo({ lat: marker.marker.getPosition().lat(), lng: marker.marker.getPosition().lng() })
                mapInstance.setZoom(21)
            }
        } else if (redrawCluster) {
            setRedrawCluster(false)
            mapInstance.setOptions({
                ...mapOptions,
                ...clusterMapOptions
            })
            mapInstance.setZoom(lastZoomBeforeSelectedVehicle)

            clusterManager.showClusters()
        }
    }, [selectedVehicles?.length, currentVehicleActive])
    return <></>
}

export default React.memo(MarkerVehicle2)
